module.exports = __webpack_public_path__ + "img/logo.d20a482f.png";